import React, { memo, FC, useMemo, useState } from "react";
import classnames from "classnames";
import { SelectProps, Select, Form, Row, Col, Modal } from "antd";
import { LabeledValue } from "antd/es/select";
import moment from "moment";
import { ReactComponent as Close } from '@components/Icons/close-1.svg';
import { useMediaQuery } from 'react-responsive';
import { ReactComponent as ArrowDown } from "../../Icons/arrow-down.svg";

interface Props extends SelectProps {
  label?: string;
  rules?: object[];
  name: string;
  // options: LabeledValue[];
  extra?: React.ReactNode;
}

const { Option } = Select;

const AppSelectYear: FC<Props> = memo(({ ...props }) => {
  const { name, label, rules, className, clearIcon, extra } = props;
  const isMobile = useMediaQuery({
    query: '(max-width: 768px)'
  });

  const options = useMemo(() => {
    const years: LabeledValue[] = [{ label: "1980年以前", value: 1979 }];
    for (let index = 1980; index <= moment().year(); index++) {
      years.push({ label: index, value: index });
    }
    return years.reverse();
  }, []);
  const [yearVisible, setYearVisible] = useState<boolean>(false);

  return (
    <Row>
      <Col xs={24} id={name}>
        <Form.Item
          labelCol={{ span: 24 }}
          name={name}
          label={label}
          rules={rules}
          extra={extra}
          validateTrigger={["onBlur", "onChange"]}
        >
          <Select
            {...props}
            placeholder="年"
            className={classnames("app-select app-year-select", className)}
            dropdownClassName={classnames("p-0 br-8")}
            // dropdownClassName="ant-select-custom-dropdown"
            suffixIcon={<ArrowDown />}
            getPopupContainer={() => document.getElementById(`${name}`) as HTMLElement}
            listItemHeight={isMobile ? 48 : 32}
            listHeight={isMobile ? 480 : 256}
            clearIcon={clearIcon}
            dropdownRender={menu => (
              isMobile ? (
                <Modal visible={yearVisible} className="datepicker-dropdown-modal" closable={false} centered destroyOnClose>
                  <div className={ classnames("ant-select-custom-dropdown") }>
                    {menu}
                  </div>
                </Modal>
              ) : (
                <div className="ant-select-custom-dropdown">{menu}</div>
              )
            )}
            onDropdownVisibleChange={(visible) => {
              setYearVisible(visible);
            }}
          >
            {options?.map((option: LabeledValue, index: number) => (
              <Option key={index} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
});

export default AppSelectYear;

AppSelectYear.defaultProps = { clearIcon: <Close /> };
